import Types from "@Types";

const reducer = (state = [], action) => {
    switch (action.type) {
        //? inset Customer
        case Types.VideoCategory.insert:
            return [...state, action.payload.value];
        //? update Customer
        case Types.VideoCategory.update:
            return [
                ...state.map((x) => {
                    if (x.Series === action.payload.Series) return action.payload.value;
                    else return x;
                }),
            ];
        //? delete Customer
        case Types.VideoCategory.delete:
            return [...state.filter((x) => x.Series !== action.payload.Series)];
        // ? clear all data
        case Types.clear:
            return [];
        //? set Customer
        case Types.VideoCategory.set:
            return action.payload ?? [];
        // ? default
        default:
            return state;
    }
};

export default reducer;
